import {compact} from '@benchling/js-utils';
import {css} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AvatarShape, AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {AvatarWithName} from 'ui-library/avatar/AvatarWithName';
import * as DateUtil from 'util/DateUtil';

import FormattedTextField from '../fields/FormattedTextField';
import getStudiesRowContent from '../fields/getStudiesRowContent';
import SourceTasksAndOutputsField from '../fields/SourceTasksAndOutputsField';
import {
  PROCESS_TASK_DETAILS_LABELS,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
} from '../ProcessTaskDetailsPageConstants';
import {ProcessTaskDetailsRowContent, ProcessTaskGql} from '../ProcessTaskDetailsPageConstants';

export function getProceduresTaskMetadataRows(
  processTask: ProcessTaskGql
): Array<ProcessTaskDetailsRowContent> {
  return compact([
    {
      label: PROCESS_TASK_DETAILS_LABELS.ID,
      component: <FormattedTextField text={processTask.humanId} />,
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.CREATOR,
      component: (
        <AvatarWithName
          avatarInfo={processTask.creator}
          size={AvatarSize.XXSMALL}
          shape={AvatarShape.CIRCLE}
          showTooltip={true}
        />
      ),
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.CREATED,
      component: <FormattedTextField text={DateUtil.readableTime(processTask.createdAt)} />,
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.MODIFIED,
      component: (
        <span className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}>
          {DateUtil.readableTime(processTask.modifiedAt)}
        </span>
      ),
    },
    processTask.rootTask != null
      ? {
          label: PROCESS_TASK_DETAILS_LABELS.SOURCES,
          component: <SourceTasksAndOutputsField processTask={processTask} />,
        }
      : null,
    BenchlingConfig.STUDIES_ENABLE ? getStudiesRowContent(processTask) : null,
  ]);
}
